<template>
    <!-- https://www.svgrepo.com/svg/502841/shuffle-arrow?edit=true -->
    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier">
            <path
                d="M4 8H6.8915C7.58108 8 8.22202 8.35524 8.5875 8.94L12.4125 15.06C12.778 15.6448 13.4189 16 14.1085 16H20M20 16L17.5 13.5M20 16L17.5 18.5M14 8H20M20 8L17.5 10.5M20 8L17.5 5.5M4 16H8"
                stroke="#F09A0FFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "AutoLimitIcon",
};
</script>

<style scoped></style>
